import script from "./FileDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileDownload.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__